import Icon from '@mdi/react';
import { mdiMessage } from '@mdi/js';
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const Home = () => {

 	const location = useLocation();

	return(
		<>
		<div className="d-flex justify-content-center">
			<h2 className="home">
				Ch<Icon path={mdiMessage} size={10}/>tS
			</h2>
		</div>
		<div className="d-flex justify-content-center">
			<Spinner animation="grow" variant="primary" />
		    <Spinner animation="grow" variant="success" />
		    <Spinner animation="grow" variant="danger" />
		</div>
		</>
	)
}

export default Home;